import { autoserializeAs } from "cerialize";
import { OrganizationRiderCreationRequest } from "./organization-rider-creation-request";
import { Rider } from "./rider";
import { Address } from "./address";

export class RiderCreationRequest {
  @autoserializeAs(Rider)
  rider: Rider;

  @autoserializeAs(Address)
  address: Address

  @autoserializeAs(OrganizationRiderCreationRequest)
  organizationRiderCreationRequests: Array<OrganizationRiderCreationRequest>;
}
